(function(app) {

    app.provider("marketingTrackerEventApi",
    [
        function() {
            this.$get = [
                "marketingTrackerApiGateway", function(marketingTrackerApiGateway) {
                    var service = {};

                    service.getEvent = function(eventGroupId, eventId) {
                        return marketingTrackerApiGateway.get("/EventGroups/" + eventGroupId + "/Events/" + eventId);
                    };

                    service.getAncillaryEvent = function(ancillaryEventGroupId, ancillaryEventId) {
                        return marketingTrackerApiGateway
                            .get("/AncillaryEventGroups/" +
                                ancillaryEventGroupId +
                                "/AncillaryEvents/" +
                                ancillaryEventId);
                    };

                    service.getEventGroup = function(eventGroupId) {
                        return marketingTrackerApiGateway.get("/EventGroups/" + eventGroupId);
                    };

                    service.getAncillaryEventGroup = function(ancillaryEventGroupId) {
                        return marketingTrackerApiGateway.get("/AncillaryEventGroups/" + ancillaryEventGroupId);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line